import type { ReactElement } from 'react'
import Image from 'next/image'

const ForProClient = (): ReactElement | null => {

  return (
    <div className="container bg-linear-to-r from-[#1F0822] to-[#3F0647] pt-15 py-18 rounded-3xl px-18">
      <h2 className="text-2xl lg:text-3xl font-medium text-center mb-12 text-white">
        今日も、あなたを必要としているクライアントがいます
      </h2>
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-15">
        <article className="flex flex-col items-center">
          <Image
            src="/images/for-pro/v2/client-1.svg"
            alt=""
            width={60}
            height={60}
            className="mb-4"
          />
          <h3 className="text-base sm:text-xl font-medium text-white mb-3">
            活躍の場を広げる
          </h3>
          <p className="text-sm sm:text-base leading-tight text-white">
            音楽制作を求めるクライアントと直接繋がれる場所。アーティスト、アイドル、企業案件まで、多様な出会いがあります。
          </p>
        </article>
        <article className="flex flex-col items-center">
          <Image
            src="/images/for-pro/v2/client-2.svg"
            alt=""
            width={60}
            height={60}
            className="mb-4"
          />
          <h3 className="text-base sm:text-xl font-medium text-white mb-3">
            実績を作る
          </h3>
          <p className="text-sm sm:text-base leading-tight text-white">
            受注した依頼は、あなたの実績になり、次の仕事に繋がっていきます。
          </p>
        </article>
        <article className="flex flex-col items-center">
          <Image
            src="/images/for-pro/v2/client-3.svg"
            alt=""
            width={60}
            height={60}
            className="mb-4"
          />
          <h3 className="text-base sm:text-xl font-medium text-white mb-3">
            あなたを必要とする人に届く
          </h3>
          <p className="text-sm sm:text-base leading-tight text-white">
            プロフィールや実績を公開することで、あなたのスキルを探しているクライアントの目に留まりやすくなります。
          </p>
        </article>
        <article className="flex flex-col items-center">
          <Image
            src="/images/for-pro/v2/client-4.svg"
            alt=""
            width={60}
            height={60}
            className="mb-4"
          />
          <h3 className="text-base sm:text-xl font-medium text-white mb-3">
            音楽に本気な人と出会える
          </h3>
          <p className="text-sm sm:text-base leading-tight text-white">
            音楽制作を通して、新しい才能や仲間に出会える場所です。
          </p>
        </article>
      </div>
    </div>
  )
}

export default ForProClient
